import {_, React, observer, observable, computed, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource} from '@api'
import {CatalogItemSidebarDetailsStore, DetailsTemplate_OverviewGrid, useCatalogItemSidebarDetailsStore, useVipLocalStore, VipLocalStore} from '@modules'
import {ICatalogItemDetailTemplate, StoresInstance} from '@stores'
import {IDisposer} from 'mobx-utils'
import * as css from './CustomDetailsTemplate.css'

/// region Store

export class CustomDetailsTemplateStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: { details : CatalogItemSidebarDetailsStore} & Omit<MyProps, 'className'>) {
    super(stores)
  }

  registerEffects = () => {
    const toDispose: Array<IDisposer> = []

    return () => toDispose.forEach(d => d())
  }

  get details() { return this.props.details}
  get template() { return this.props.template}

  @observable foo = false

  @computed get component() {
    const {template: {component}} = this
    switch (component) {
      case 'overview-grid':
        return <DetailsTemplate_OverviewGrid />
      default:
        return <div>Unknown template component {component}</div>
    }
  }

  @action verb = () => {}
}

export const CustomDetailsTemplateStoreContext = React.createContext<CustomDetailsTemplateStore>(null)
export const useCustomDetailsTemplateStore = () => React.useContext(CustomDetailsTemplateStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
  template: ICatalogItemDetailTemplate
}

export const CustomDetailsTemplate = observer<MyProps>(function CustomDetailsTemplate({className, ...props}) {
  const details = useCatalogItemSidebarDetailsStore(),
    obsProps = useAsObservableSource({details, template: props.template}),
    store = useVipLocalStore((stores) => new CustomDetailsTemplateStore(stores, obsProps)),
    {template, component} = store

  useEffect(() => store.registerEffects(), [])
  // console.log(props, obsProps)
  return (
    <CustomDetailsTemplateStoreContext.Provider value={store}>
      <div className={classNames(css.root, className)}
           data-template={true}
           data-component={template.component}>
        {component}
      </div>
    </CustomDetailsTemplateStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/Modal/CustomDetailsTemplate.tsx